<template>
  <div class="empty_data_info">
    {{text}}
  </div>
</template>

<style lang="scss" scoped>
.empty_data_info{
  height: 60px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  text-align: center;
  line-height: 60px;
  background: white;
  color: #606266
}
</style>

<script>
export default {
  name: 'base-empty-data',
  props: {
    text: {
      required: false,
      default: () => '暂无数据'
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/component/base-empty-data.vue